export default __webpack_public_path__ + "static/media/ch.a0ac3f54.svg";